<script setup lang="ts">
const visible = ref(false)
const src = ref()

function open(params: { src: string }) {
  visible.value = true
  src.value = scaleImage(params.src, [2560, 1440])
}

defineExpose({ open })
</script>

<template>
  <LdDialog v-model="visible">
    <img class="size-full max-h-80vh max-w-80vw rd-8px" :src="src">
  </LdDialog>
</template>

<style lang="scss" scoped>
</style>
